import React from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableHeadText, TableColText, TableColLabelValue } from '../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import Bar from '../../../../../components/pdf/Bar'
import View from '../../../../../components/pdf/View'
import {
  toCurrency,
  findReplyByQuestionId,
  filterRepliesByParentReference,
  currencyToNumber,
  mountAssetsValues
} from '../../_helpers/pdfHelpers'
import { useMemo } from 'react'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { useBrotherServiceOrder } from '../../_load/BrotherServiceOrderLoader'

const BudgetManual = () => {
  const serviceOrder = useServiceOrder()
  const brotherServiceOrder = useBrotherServiceOrder()

  const maisServiceOrder = brotherServiceOrder[0] ? brotherServiceOrder[0] : serviceOrder

  const assetsData = useMemo(() => {
    const assetsData = []
    const mainAssetReply = findReplyByQuestionId(maisServiceOrder.replies, 23445)
    const assets = filterRepliesByParentReference(maisServiceOrder.replies, mainAssetReply.question.reference)
    const assetsValues = mountAssetsValues(assets)
    assetsValues.forEach(asset => {
      const assetName = asset[23446]
      const qtd = asset[23447]
      const finalUnitario = asset[23536]
      const finalTotal = asset[23538]

      assetsData.push({
        description: assetName,
        qtd: Number(qtd),
        unitPrice: currencyToNumber(finalUnitario),
        totalPrice: currencyToNumber(finalTotal)
      })
    })

    return assetsData
  }, [maisServiceOrder])

  const workHoursData = useMemo(() => {
    const workHoursData = []
    const mainWorkHourReply = findReplyByQuestionId(maisServiceOrder.replies, 23520)
    const workHours = filterRepliesByParentReference(maisServiceOrder.replies, mainWorkHourReply.question.reference)
    const workHoursValues = mountAssetsValues(workHours)
    workHoursValues.forEach(workHour => {
      const description = workHour[23521]
      const finalTotal = workHour[23579]

      workHoursData.push({
        description,
        totalPrice: currencyToNumber(finalTotal)
      })
    })

    return workHoursData
  }, [maisServiceOrder])

  const sumTotalAssets = useMemo(() => {
    const total = {
      totalQtd: 0,
      totalUnitPrice: 0,
      sumWorkHour: 0,
      totalWorkHour: 0,
      total: 0
    }
    assetsData.forEach(eqp => {
      total.totalQtd += eqp.qtd
      total.totalUnitPrice += eqp.unitPrice
      total.total += eqp.qtd * eqp.unitPrice
      total.sumWorkHour += eqp.workHour
      total.totalWorkHour += eqp.qtd * eqp.workHour
    })
    return total
  }, [assetsData])

  const sumTotalWorkHours = useMemo(() => {
    const total = {
      totalWorkHour: 0
    }
    workHoursData.forEach(eqp => {
      total.totalWorkHour += eqp.totalPrice
    })
    return total
  }, [workHoursData])

  const acceptanceItens = useMemo(() => {
    if (brotherServiceOrder[0]) {
      return {
        orderNumber: findReplyByQuestionId(serviceOrder.replies, 15506).value,
        item: findReplyByQuestionId(serviceOrder.replies, 15507).value
        // orderNumber: 0,
        // item: 0
      }
    }
    return
  }, [brotherServiceOrder, serviceOrder])

  return (
    <View>
      {acceptanceItens && (
        <>
          <Text bold size="h4" align="left">
            Itens de aceite
          </Text>
          <Table width="100%" style={{ border: '' }}>
            <TableRow color={'transparent'}>
              <TableColLabelValue colSpan={2} label={'Item'} value={acceptanceItens.item} style={{ border: '' }} />
            </TableRow>
            <TableRow color={'transparent'}>
              <TableColLabelValue
                colSpan={2}
                label={'Número do pedido'}
                value={acceptanceItens.orderNumber}
                style={{ border: '' }}
              />
            </TableRow>
          </Table>
          <Separator weight={4} />
          <Bar />
        </>
      )}
      <Text bold size="h4" align="left">
        Fatura - Equipamentos
      </Text>
      <Table justify="space-between" width={'100%'}>
        <TableRow>
          <TableHeadText width={'60%'} align="center">
            Descrição
          </TableHeadText>
          <TableHeadText align="center">Qtd</TableHeadText>
          <TableHeadText align="center">Preço Unitário</TableHeadText>
          <TableHeadText align="center">Preço Total</TableHeadText>
        </TableRow>
        {assetsData?.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            <TableColText width={'60%'} align="center">
              {row.description}
            </TableColText>
            <TableColText align="center">{row.qtd}</TableColText>
            <TableColText align="center">{toCurrency(row.unitPrice)}</TableColText>
            <TableColText align="center">{toCurrency(row.totalPrice)}</TableColText>
          </TableRow>
        ))}
        <TableRow>
          <TableHeadText align="center">Total</TableHeadText>
          <TableHeadText align="center">{sumTotalAssets.totalQtd}</TableHeadText>
          <TableHeadText align="center">{toCurrency(sumTotalAssets.totalUnitPrice)}</TableHeadText>
          <TableHeadText align="center">{toCurrency(sumTotalAssets.total)}</TableHeadText>
        </TableRow>
      </Table>

      <Separator weight={4} />

      <>
        <Text bold size="h4" align="left">
          Fatura - Mão de Obra
        </Text>
        <Table justify="space-between" width={'100%'}>
          <TableRow>
            <TableHeadText width={'60%'} align="center">
              Descrição
            </TableHeadText>
            <TableHeadText align="center">Preço Total</TableHeadText>
          </TableRow>
          {workHoursData?.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              <TableColText width={'60%'} align="center">
                {row.description}
              </TableColText>
              <TableColText align="center">{toCurrency(row.totalPrice)}</TableColText>
            </TableRow>
          ))}
          <TableRow>
            <TableHeadText align="center">Total</TableHeadText>
            <TableHeadText align="center">{toCurrency(sumTotalWorkHours.totalWorkHour)}</TableHeadText>
          </TableRow>
        </Table>
        <Separator weight={4} />
      </>

      <>
        <Text bold size="h4" align="right">
          Total: {toCurrency(sumTotalAssets.total + sumTotalWorkHours.totalWorkHour)}
        </Text>
        <Separator weight={4} />
        <Bar />
      </>
    </View>
  )
}

export default BudgetManual
